/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type AgentRow_agent$ref = any;
type ShowMoreFooter_connection$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type Agents_organization$ref: FragmentReference;
declare export opaque type Agents_organization$fragmentType: Agents_organization$ref;
export type Agents_organization = {|
  +id: string,
  +uuid: string,
  +slug: string,
  +allAgents?: ?{|
    +count: number
  |},
  +agents?: ?{|
    +count: number,
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +metaData: ?$ReadOnlyArray<string>,
        +name: string,
        +$fragmentRefs: AgentRow_agent$ref,
      |}
    |}>,
    +$fragmentRefs: ShowMoreFooter_connection$ref,
  |},
  +$refType: Agents_organization$ref,
|};
export type Agents_organization$data = Agents_organization;
export type Agents_organization$key = {
  +$data?: Agents_organization$data,
  +$fragmentRefs: Agents_organization$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "count",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "clusterQueue"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "clustered"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "isMounted"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isRunningJob"
    },
    {
      "defaultValue": 100,
      "kind": "LocalArgument",
      "name": "pageSize"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "search"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "Agents_organization",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "uuid",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slug",
      "storageKey": null
    },
    {
      "condition": "isMounted",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": "allAgents",
          "args": null,
          "concreteType": "AgentConnection",
          "kind": "LinkedField",
          "name": "agents",
          "plural": false,
          "selections": [
            (v1/*: any*/)
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "clusterQueue",
              "variableName": "clusterQueue"
            },
            {
              "kind": "Variable",
              "name": "clustered",
              "variableName": "clustered"
            },
            {
              "kind": "Variable",
              "name": "first",
              "variableName": "pageSize"
            },
            {
              "kind": "Variable",
              "name": "isRunningJob",
              "variableName": "isRunningJob"
            },
            {
              "kind": "Variable",
              "name": "search",
              "variableName": "search"
            }
          ],
          "concreteType": "AgentConnection",
          "kind": "LinkedField",
          "name": "agents",
          "plural": false,
          "selections": [
            (v1/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "AgentEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Agent",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "metaData",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    },
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "AgentRow_agent"
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "ShowMoreFooter_connection"
            }
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "Organization",
  "abstractKey": null
};
})();
// prettier-ignore
(node/*: any*/).hash = '5765e4a0ee2e44de0fe3515f1504dc6f';

module.exports = node;
